import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import apiFetchEditRoute from '../../api/EditRouteAPI';
import { ROUTE_EDIT_REQUEST } from '../actions/types/EditRouteActionsTypes';
import { putRouteEditSuccessActionCreator, putRouteEditFailureActionCreator } from '../actions/EditRouteActions';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';

function* doRouteEditWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchEditRoute, action.payload);
    yield put(putRouteEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: <FormattedMessage
        id="notification.route.edit.success"
        values={{ transactionProcessingFrequency: process.env.transactionProcessingFrequency }}
      />,
    }));
  } catch (error) {
    let message = formatMessage(lang, 'app.server.error');
    if (error.response.data.BusinessError !== undefined) {
      message = formatMessage(lang, error.response.data.BusinessError.messageKey);
    }
    yield put(putRouteEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message,
    }));
  }
}

function* doRouteEditWatcher() {
  yield takeLatest(ROUTE_EDIT_REQUEST, doRouteEditWorker);
}

export default doRouteEditWatcher;
